import { Pipe } from '@angular/core';

@Pipe({
    name: 'huf',
})
export class HUFPipe {
    transform(value, status) {
        if (value) {
            //return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            return value.toString().replace('HUF', '').replace('Ft.', '');
        } else return value;
    }
}
